import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewDistributor = (search = "") => { 
    return useQuery({ 
        queryKey: ['viewdistributor', search], 
        queryFn: async () => { 
            const res = await api.get('/distributor/view', {
                params: {
                    search: search?.trim() || undefined,
                },
            }); 
            return res.data; 
        }
     });
};  